module.exports = __webpack_public_path__ + "static/img/bei-an.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bei-an.png
// module id = m9vJ
// module chunks = 3